"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
/**
 * Primary Action Button for a form.
 * @param props component props to pass to <button/>
 *        Anything which <button/> accepts should be valid.
 * @param buttonText {string} button label /text
 */
function FormPrimaryActionButton(_a) {
    var buttonText = _a.buttonText, props = tslib_1.__rest(_a, ["buttonText"]);
    return (React.createElement("div", { className: "form-section form-section--actions" },
        React.createElement("button", tslib_1.__assign({ type: "submit", className: "form-section__primary-action" }, props), buttonText)));
}
exports.default = FormPrimaryActionButton;
//# sourceMappingURL=form_primary_action_button.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/onboarding/form_primary_action_button.js
// module id = u+WP
// module chunks = 20 21